$(document).ready(function(){
  //*Dev only
  $('.product-video').on('click',function(){
    var displayWidth = $('.prd_big_slider').width() -2;
    var displayHeight = $('.prd_big_slider').height() -2;
    
    console.log($(this).attr('data-video-url'));
    var vEmbed = '<iframe width="'+ displayWidth +'" height="'+ displayHeight +'" src="'+ $(this).attr('data-video-url') +'?autoplay=1" frameborder="0" allowfullscreen=""></iframe>';                   

    $('.prd_big_slider').html(vEmbed);
  });
  
  //patch to fix the fact that img tag is being replaced for video function.
  //previous theme sets the SRC attribute of img tag found inside of prd_big_slider
  $('.product_lrg_img').on('click',function(){
    var imgSrc = '<img src="" class="product_lrg_img" alt>';
    $('.prd_big_slider').html(imgSrc);
  });
  
  
});
